export enum FamilyNumberChildren {
    small,
    large
}

export const numbersChildren: any[] = [
  { id: 0, name: 'Малодетная' },
  { id: 1, name: 'Многодетная' },
];